import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../AppContext';
import { useTranslation } from 'react-i18next';

const DiscoveryView = () => {
    const { t } = useTranslation();
    const { currentUserProfile, updateUserProfile } = useAppContext();
    
    const [discoverySettings, setDiscoverySettings] = useState({
        locationEnabled: false,
        discoveryRadius: 50, // default radius in km
    });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (currentUserProfile) {
            setDiscoverySettings({
                locationEnabled: currentUserProfile.locationEnabled || false,
                discoveryRadius: currentUserProfile.discoveryRadius || 50,
            });
        }
        setIsLoading(false);
    }, [currentUserProfile]);

    const handleToggleLocation = () => {
        const newSettings = {
            ...discoverySettings,
            locationEnabled: !discoverySettings.locationEnabled,
        };
        setDiscoverySettings(newSettings);
        updateUserProfile(currentUserProfile.id, { locationEnabled: newSettings.locationEnabled });
    };

    const handleRadiusChange = (e) => {
        const newRadius = parseInt(e.target.value, 10);
        const newSettings = {
            ...discoverySettings,
            discoveryRadius: newRadius,
        };
        setDiscoverySettings(newSettings);
        // Debounced update would be ideal here
        updateUserProfile(currentUserProfile.id, { discoveryRadius: newRadius });
    };

    if (isLoading) {
        return <div>{t('loading')}</div>;
    }

    return (
        <div className="bg-black/20 backdrop-blur-md rounded-2xl p-6 border border-slate-700/50">
            <h2 className="text-3xl font-bold font-playfair mb-2 text-teal-300">{t('settings.location.title')}</h2>
            <p className="mb-6 text-gray-400">{t('settings.location.description')}</p>

            <div className="space-y-6">
                {/* Enable/Disable Location */}
                <div className="flex items-center justify-between bg-slate-800/50 p-4 rounded-lg border border-slate-700/50">
                    <span className="font-medium">{t('settings.location.enableDiscovery')}</span>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            checked={discoverySettings.locationEnabled}
                            onChange={handleToggleLocation}
                            className="sr-only peer"
                        />
                        <div className="w-11 h-6 bg-gray-600 rounded-full peer peer-focus:ring-4 peer-focus:ring-teal-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-teal-600"></div>
                    </label>
                </div>

                {/* Discovery Radius */}
                {discoverySettings.locationEnabled && (
                    <div className="bg-slate-800/50 p-4 rounded-lg border border-slate-700/50">
                        <label htmlFor="radius-slider" className="font-medium mb-2 block">{t('settings.location.searchRadius')} ({discoverySettings.discoveryRadius} km)</label>
                        <input
                            id="radius-slider"
                            type="range"
                            min="5"
                            max="200"
                            step="5"
                            value={discoverySettings.discoveryRadius}
                            onChange={handleRadiusChange}
                            className="w-full h-2 bg-gray-600 rounded-lg appearance-none cursor-pointer accent-teal-500"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default DiscoveryView;